import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RiskScoreItem } from '../../../types';
import { corporateClientsRiskApi } from '../services';

export interface CorporateClientsProductsItemState {
  itemId?: string;
  item?: RiskScoreItem;
}

const initialState: CorporateClientsProductsItemState = {};

export const corporateClientsProductsItemSlice = createSlice({
  name: 'corporateClientsProductsItem',
  initialState,
  reducers: {
    clearProductRiskItemState: (state) => {
      state.itemId = undefined;
      state.item = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      corporateClientsRiskApi.endpoints.getCorporateProduct.matchFulfilled,
      (state, action: PayloadAction<{ data: RiskScoreItem }>) => {
        state.item = action.payload.data;
        state.itemId = action.payload.data.id;
      },
    );
  },
});

export const { clearProductRiskItemState } =
  corporateClientsProductsItemSlice.actions;

export default corporateClientsProductsItemSlice.reducer;
